import { useEffect, useRef } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { requestCounter } from "../../api/proxy/RequestCounter";

export default function GlobalBackdrop() {
  const openRef = useRef(false);
  const backdropRef = useRef(null);

  useEffect(() => {
    return requestCounter.subscribe((count) => {
      const shouldOpen = count > 0;

      if (openRef.current !== shouldOpen) {
        openRef.current = shouldOpen;
        if (backdropRef.current) {
          backdropRef.current.setAttribute(
            "style",
            `display: ${shouldOpen ? "flex" : "none"}`
          );
        }
      }
    });
  }, []);

  return (
    <Backdrop
      ref={backdropRef}
      open={false}
      sx={{ zIndex: 2000 }}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
